"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.HANDLE_POSITIONS = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var core_1 = require("@material-ui/core");
function Handle(_a) {
    var position = _a.position, handleColor = _a.handleColor, divProps = __rest(_a, ["position", "handleColor"]);
    var classes = useStyles({ position: position, handleColor: handleColor });
    return jsx_runtime_1.jsx("div", __assign({ className: classes.root }, divProps), void 0);
}
exports.default = Handle;
var useStyles = core_1.makeStyles({
    root: {
        background: function (_a) {
            var handleColor = _a.handleColor;
            return handleColor !== null && handleColor !== void 0 ? handleColor : '#004884';
        },
        position: 'absolute',
        top: function (_a) {
            var position = _a.position;
            return (position.includes('Top') ? 0 : '100%');
        },
        left: function (_a) {
            var position = _a.position;
            return (position.includes('Left') ? 0 : '100%');
        },
        width: '16px',
        height: '16px',
        borderRadius: '50%',
        transform: 'translate3d(-50%, -50%, 0)',
        cursor: function (_a) {
            var position = _a.position;
            return CURSOR_MAP[position];
        },
    },
});
exports.HANDLE_POSITIONS = {
    TopLeft: 'TopLeft',
    TopRight: 'TopRight',
    BottomLeft: 'BottomLeft',
    BottomRight: 'BottomRight',
};
var CURSOR_MAP = (_a = {},
    _a[exports.HANDLE_POSITIONS.TopLeft] = 'nwse-resize',
    _a[exports.HANDLE_POSITIONS.TopRight] = 'nesw-resize',
    _a[exports.HANDLE_POSITIONS.BottomLeft] = 'nesw-resize',
    _a[exports.HANDLE_POSITIONS.BottomRight] = 'nwse-resize',
    _a);
//# sourceMappingURL=Handle.js.map